import React from 'react';
import { Form, Input } from "antd";
import { Video, Image } from '@chatui/core';

const AntdFormContent = (item, index) => {
    switch (Number(item.type)) {
        /* date input */
        case 1:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input value={item.content_value} disabled />
            </Form.Item>
        /* date + time */
        case 2:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input value={item.content_value} disabled />
            </Form.Item>
        /* multi line text input */
        case 3:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input.TextArea autoSize={{ minRows: 3 }} value={item.content_value} disabled />
            </Form.Item>
        /* single line text input */
        case 4:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input value={item.content_value} disabled />
            </Form.Item>
        /* number input */
        case 5:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input value={item.content_value} disabled />
            </Form.Item>
        /* drop down list */
        case 6:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input value={item.content_value} disabled />
            </Form.Item>
        /* 身份证 ()*/
        case 20:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input value={item.content_value} disabled />
            </Form.Item>
        /* 生日 */
        case 21:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input value={item.content_value} disabled />
            </Form.Item>
        /* 标题 */
        case 22:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input value={item.content_value} disabled />
            </Form.Item>
        /* 内容 */
        case 23:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input.TextArea autoSize={{ minRows: 3 }} value={item.content_value} disabled />
            </Form.Item>
        /* video link */
        case 24:
            let videoArr = []
            if (item.content_value) {
                const videoSrc = JSON.parse(item.content_value);
                if (Array.isArray(videoSrc)) {
                    videoArr = videoSrc
                } else {
                    videoArr = [videoSrc]
                }
            }
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <div style={{ display: 'flex' }}>
                    {videoArr.map((item, index) => {
                        return <Video key={index} src={item} />
                    })}
                </div>
            </Form.Item>
        /* image file */
        case 25:
            let imageArr = []
            if (item.content_value && Array.isArray(JSON.parse(item.content_value))) {
                const imageSrc = JSON.parse(item.content_value);
                if (Array.isArray(imageSrc)) {
                    imageArr = imageSrc
                } else {
                    imageArr = [imageSrc]
                }
            }
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <div style={{ display: 'flex' }}>
                    {imageArr.map((item, index) => {
                        return <Image key={index} src={item} alt={index} fluid />
                    })}
                </div>
            </Form.Item>
        /* game role, platform + server + role_id */
        case 26:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input value={item.content_value} disabled />
            </Form.Item>
        /* email */
        case 27:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input value={item.content_value} disabled />
            </Form.Item>
        /* province + city */
        case 28:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input value={item.content_value} disabled />
            </Form.Item>
        /* IM contact */
        case 29:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input value={item.content_value} disabled />
            </Form.Item>
        /* phone number */
        case 30:
            return <Form.Item
                key={index}
                label={item.field_name}
                required={item.required}
            >
                <Input value={item.content_value} disabled />
            </Form.Item>
        default:
            return null
    }
}

export default AntdFormContent;
